import { render, staticRenderFns } from "./RemoteDataTable.vue?vue&type=template&id=0c183a44"
import script from "./RemoteDataTable.vue?vue&type=script&lang=ts"
export * from "./RemoteDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports